import { upperFirst } from 'lodash-es';

export const titleize = (value: string): string =>
  value.toLowerCase().replace('_', ' ').replace(/\w\S*/g, upperFirst);
